import { Dispatch, SetStateAction, useContext } from "react"
import { PopupDeleteCategoriesWrapper } from "./styles"
import { IoClose } from "react-icons/io5"
import { FaRegTrashAlt } from "react-icons/fa"
import { useCategoryMangment } from "@services"
import { ToastMessageContext } from "@context/toast-message-cotnext"
import { useQueryClient } from "@tanstack/react-query"
import { GetListingManagementCategoriesUrl } from "../../../utils/constants"
import { useTranslation } from "react-i18next"

interface IProps {
	setDeleteCategories: Dispatch<SetStateAction<boolean>>
	recordData:
		| {
				id: number
				categoryId: number
				categoryName: string
				propertyCounts: number
				channals: number[]
		  }
		| undefined
}
export default function PopupDeleteCategories({
	setDeleteCategories,
	recordData,
}: IProps) {
	const { showSuccess } = useContext(ToastMessageContext)
	const { deleteCategoryMutate } = useCategoryMangment()
	const queryClient = useQueryClient()
	const {t}=useTranslation();

	const { mutateAsync: deleteCategory } = deleteCategoryMutate({
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: [GetListingManagementCategoriesUrl],
			})
		}
	})
	const deleteCategoryFun = async () => {
		if (!recordData?.categoryId) return
		const data = await deleteCategory(recordData?.categoryId)
		// showSuccess(data.data.result)
		showSuccess(t('CATEGORYMANAGER.deleteSuccess'))
		setDeleteCategories(false)
	}
	return (
		<PopupDeleteCategoriesWrapper>
			<div className='popupContainer'>
				<div>
					<button onClick={() => setDeleteCategories(false)}>
						<IoClose />
					</button>
				</div>
				<div>
					<div>
						<FaRegTrashAlt />
					</div>
					<p>{t('CATEGORYMANAGER.AreDeleteCat')}</p>
				</div>
				<div>
					<button type='button' onClick={() => setDeleteCategories(false)}>
						{t('CATEGORYMANAGER.cancel')}
					</button>
					<button type='button' onClick={() => deleteCategoryFun()}>
						{t('CATEGORYMANAGER.delete')}
					</button>
				</div>
			</div>
		</PopupDeleteCategoriesWrapper>
	)
}